import { render, staticRenderFns } from "./HtmlCardConfig.vue?vue&type=template&id=4f699fea&"
import script from "./HtmlCardConfig.vue?vue&type=script&lang=js&"
export * from "./HtmlCardConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports